const getters = {
    leavetypes: (state) => state.leavetypes,
    leavetypeId: (state) => state.leavetypeId,
    loading: state => state.loading
};

export default getters;